<div *ngIf="selectedNodeType === 'TABLE' || (isAllowedValuesEnabled && isGenerationWizard)">
  <div class="table-header property-header" >
    <div class="table-title header">
      <div class="header">{{ selectedPropertyTitle }}</div>
    </div>
    <div class="formgroup-inline searchbox-button">
      <div class="field">
        <div class="p-inputgroup">
          <span class="p-inputgroup-addon"><i class="pi pi-search"></i></span>
          <input
            type="text"
            pInputText
            placeholder="Search"
            [(ngModel)]="searchTerm"
            name="searchTerm"
            [ngModelOptions]="{ standalone: true, updateOn: 'change' }"
          />
          <span
            class="p-inputgroup-addon"
            *ngIf="searchTerm !== '' && searchTerm !== undefined && searchTerm !== null"
            (click)="clearFilter()"
            tabindex="0"
            (keyup.enter)="clearFilter()"
            role="button"
            aria-label="Clear filter"
            ><i class="pi pi-times"></i
          ></span>
        </div>
      </div>
    </div>
  </div>

  <div class="property-content pt-1" *ngIf="selectedNodeType === 'TABLE'">
		<div class="position-relative row form-group prop-elems" *ngIf="isGenerationWizard">
		<label
			for="parentTable"
			class="col-sm-6 col-form-label"
		>
			<span>{{ 'PARENT_TABLE_LABEL' | translate }}</span>
			<i
				class="fa fa-info-circle field-info"
				showDelay="100"
				hideDelay="100"
				tooltipPosition="bottom"
				tooltipStyleClass="label-tooltip custom-tooltip-properties"
				pTooltip="{{ parentTableTooltipInfo | translate }}"
			></i>

		</label>

		<div class="col-sm-6 p-0 input-ctrl auto-comp-wrap">
			<p-autocomplete
				[(ngModel)]="selectedParentTable"
				[suggestions]="parentTableSuggestions"
				appendTo="body"
				(completeMethod)="search($event)"
				(onSelect)="onParentTableSelect($event)"
				[dropdown]="true"
				[forceSelection]="true"
				[disabled]="disallowEdit"
				field="name"
				panelStyleClass="custom-autocom-panel"
				inputId="parentTable"
			>
				<ng-template
					let-field
					pTemplate="item"
				>
					<div
						class="field-item text-overflow"
						[class.bor-top]="field?.separator"
					>
						<span> {{field.name}} </span>
					</div>
				</ng-template>
			</p-autocomplete>
			<em
				class="p-select-clear-icon p-autoComplete-clear-icon pi pi-times"
				[ngClass]="{ 'disabled-em': disallowEdit }"
				*ngIf="selectedParentTable && !disallowEdit"
				(click)="onClearParentTable()"
				(keyup.enter)="onClearParentTable()"
				tabindex="0"
				aria-label="Clear autocomplete"
			>
			</em>
		</div>

	</div>
    <div class="properties-group-name">Indexes</div>
    <div class="position-relative row form-group prop-elems">
      <div class="section-table-container w-100">
        <div class="d-flex flex-column">
          <p-table
            [value]="indices | uiFilter: searchTerm : ['indexName', 'indexType', 'fieldnames']"
            dataKey="sid"
            class="fil-map-table index-table"
            styleClass="p-datatable-gridlines sql-tables"
            [style]="{ width: '100%' }"
            [scrollable]="true"
          >
            <ng-template #header>
              <tr id="index">
                <th id="index-name">Index Name</th>
                <th id="index-type">Type</th>
                <th id="index-fields">Fields</th>
                <th class="w-100-px action-items" id="index-edit-delete"></th>
              </tr>
            </ng-template>
            <ng-template #body let-column let-i="rowIndex">
              <tr>
                <td class="index-column index-name text-break">
                  <span>{{ column.indexName }}</span>
                </td>
                <td class="index-column index-type text-break">
                  <span>{{ column.indexType }}</span>
                </td>
                <td class="index-column index-fields text-break">
                  <span>{{ column.fieldnames }}</span>
                </td>
                <td class="index-column index-edit inline-delete text-break">
                  <div *ngIf="!disallowEdit">
                    <svg-icon
                      (click)="removeRow('index', column)"
                      src="assets\images\svg\trash.svg"
                      class="icon-plus cursor-pointer"
                      alt="delete"
                      aria-hidden="true"
                      showDelay="100"
                      hideDelay="100"
                      pTooltip="Delete"
                      tooltipPosition="top"
                    ></svg-icon>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template #emptymessage let-columns>
              <tr class="no-records">
                <td colspan="4" class="text-center">
                  {{ 'NO_INDEX_CREATED' | translate }}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
    <div class="properties-group-name">Foreign Key</div>
    <div class="position-relative row form-group prop-elems">
      <div class="section-table-container w-100">
        <p-table
          [value]="foreignKeys | uiFilter: searchTerm : ['fkName', 'tableName', 'indexName']"
          dataKey="sid"
          class="fil-map-table index-table"
          styleClass="p-datatable-gridlines sql-tables"
          [style]="{ width: '100%' }"
          [scrollable]="true"
        >
          <ng-template #header>
            <tr>
              <th>{{ 'NAME' | translate }}</th>
              <th>{{ 'REF_TABLE' | translate }}</th>
              <th>{{ 'REF_IND' | translate }}</th>
              <th class="w-100-px action-items"></th>
            </tr>
          </ng-template>
          <ng-template #body let-data>
            <tr>
              <td class="text-break">
                {{ data.fkName }}
              </td>
              <td class="text-break">
                {{ tableMap[data.parentTableSid] }}
              </td>
              <td class="text-break">
                {{ tableMap[data?.parentIndexId] }}
              </td>
              <td class="tbl-action">
                <div *ngIf="!disallowEdit && !data.parentChildTableFk">
                  <!-- <svg-icon (click)="editForeignKey(data)" src="assets\images\svg\edit.svg"
                                        class="icon-plus cursor-pointer mr-3" alt="edit" aria-hidden="true"
                                        showDelay="100" hideDelay="100" pTooltip="Edit"
                                        tooltipPosition="top"></svg-icon> -->
                  <svg-icon
                    (click)="removeRow('fk', data)"
                    src="assets\images\svg\trash.svg"
                    class="icon-plus cursor-pointer"
                    alt="delete"
                    aria-hidden="true"
                    showDelay="100"
                    hideDelay="100"
                    pTooltip="Delete"
                    tooltipPosition="top"
                  ></svg-icon>
                </div>
              </td></tr
          ></ng-template>
          <ng-template #emptymessage let-columns>
            <tr class="no-records">
              <td colspan="4" class="text-center">
                {{ 'NO_FOREIGN_CREATED' | translate }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>

  <!-- FIELD Properties Section - Allowed Values -->
  <div class="property-content pt-1" *ngIf="selectedNodeType === 'FIELD' && isAllowedValuesEnabled && isGenerationWizard">
    <div class="position-relative row form-group prop-elems">
      <label
        for="allowedValues"
        class="col-sm-6 col-form-label"
      >
        <span>{{ 'ALLOWED_VALUES_LABEL' | translate }}</span>
        <i
          class="fa fa-info-circle field-info"
          showDelay="100"
          hideDelay="100"
          tooltipPosition="bottom"
          tooltipStyleClass="label-tooltip custom-tooltip-properties"
          pTooltip="{{ allowedValuesInfoBubble | translate }}"
        ></i>

      </label>

      <div class="col-sm-6 p-0 input-ctrl">
        <vb-conditional-formatter
          [(ngModel)]="allowedValuesModel"
          [formData]="tableData"
          [disableField]="disallowEdit"
          [skipReferenceCheck]="true"
          [isGenerationWizard]="isGenerationWizard"
          (ngModelChange)="onAllowedValuesModelChange($event)"
          [workflowAssociated]="workflowAssociated">
        </vb-conditional-formatter>
      </div>
    </div>
  </div>

  <div class="spinner-container" *ngIf="showLoader">
    <p-progress-spinner></p-progress-spinner>
  </div>
</div>
